'use client';

import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { LocationSection } from './location-section.component';
import { useHandleLocation } from './use-handle-location.hook';

interface LocationSectionPortalProps {
  city?: string;
  state?: string;
}

function LocationSectionPortalContent({ city, state }: LocationSectionPortalProps) {
  const [container, setContainer] = useState<HTMLElement | null>(null);
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  useEffect(() => {
    if (!isHydrated) {
      return;
    }

    const element = document.getElementById('header-location-slot');
    if (element) {
      setContainer(element);
      return;
    }

    const checkInterval = setInterval(() => {
      const element = document.getElementById('header-location-slot');
      if (element) {
        setContainer(element);
        clearInterval(checkInterval);
      }
    }, 100);

    const timeout = setTimeout(() => {
      clearInterval(checkInterval);
    }, 5000);

    return () => {
      clearInterval(checkInterval);
      clearTimeout(timeout);
    };
  }, [isHydrated]);

  useHandleLocation({ city, state });

  if (!isHydrated || !container) {
    return null;
  }

  return createPortal(<LocationSection />, container);
}

export function LocationSectionPortal({ city, state }: LocationSectionPortalProps) {
  return <LocationSectionPortalContent city={city} state={state} />;
}
